import { OnlinePlayersLayout } from '@base/features/lobby/component/onlinePlayersLayout/onlinePlayersLayout';
import MainButton from '@ui-kit/components/mainButton';
import Modal from '@ui-kit/components/modal';
import { t } from '@base/utils/helpers';
import React, { useState } from 'react';
import { container } from 'tsyringe';
import { IPlayersOnlineRepository } from '@base/features/player/model/interfaces';
import { IInviteService } from '@base/features/game/model/interfaces';
import Codes from '@base/features/socket/codes';
import styles from '../styles/invitePlayersModal.module.scss';

export default function InvitePlayersModal(props: { closeModal: () => void }) {
  const [selectedPlayers, setSelectedPlayers] = useState<number[]>([]);
  const playersOnlineRepository: IPlayersOnlineRepository = container.resolve('playersOnlineRepository');
  const inviteService: IInviteService = container.resolve('inviteService');
  const [isSelectAll, setSelectAll] = useState(false);

  const handlePlayersChange = (pid: number) => {
    setSelectedPlayers((players) =>
      selectedPlayers.includes(pid) ? players.filter((p) => p !== pid) : [...players, pid]
    );
  };

  const selectAll = () => {
    setSelectedPlayers(selectedPlayers.length ? [] : [...playersOnlineRepository.getPlayersOnline().keys()]);
    setSelectAll(!isSelectAll);
  };

  const invite = () => {
    const tableId = playersOnlineRepository.me?.getTable()?.tid;
    if (!tableId) return;
    selectedPlayers.forEach((p) => {
      isSelectAll
        ? inviteService.sendInvite(p, tableId, Codes.InviteType.ALL)
        : inviteService.sendInvite(p, tableId, Codes.InviteType.IND);
    });
    setSelectAll(false);
    setSelectedPlayers([]);
    props.closeModal();
  };

  return (
    <Modal title={t('invite')} closeModal={props.closeModal} classes={{ modal: styles.inviteModal }}>
      <div className={styles.users}>
        {playersOnlineRepository.getPlayersOnline() && (
          <OnlinePlayersLayout selectedPlayers={selectedPlayers} onChange={handlePlayersChange} />
        )}
      </div>
      <button onClick={selectAll} className={styles.inviteAll}>
        {selectedPlayers.length ? t('deselect_all') : t('select_all')}
      </button>
      <footer>
        <MainButton onClick={props.closeModal}>{t('cancel')}</MainButton>
        <MainButton onClick={invite} disabled={!selectedPlayers.length}>
          {t('invite')}
        </MainButton>
      </footer>
    </Modal>
  );
}
